// PO line economics shared by the Purchasing grid, Receive popup and WO budget.
// Unit-priced PO: every line carries unit_cost. Lump-sum ("quoteline") PO: lines are the
// quote breakout (qty/UOM only) and the PO subtotal is the single quoted number; received
// value is proportional to the quantity checked in.
export const isLumpSum = (po) => po?.po_type === "quoteline";
export const lineQty = (li) => parseFloat(li?.qty) || 0;
export const lineReceived = (li) => (li?.received ? lineQty(li) : Math.min(lineQty(li), parseFloat(li?.received_qty) || 0));

export function poEconomics(po) {
  const items = po?.line_items || [];
  const lump = isLumpSum(po);
  const ordered = items.reduce((s, li) => s + lineQty(li), 0);
  const received = items.reduce((s, li) => s + lineReceived(li), 0);
  const frac = ordered > 0 ? received / ordered : (items.length && items.every((li) => li.received) ? 1 : 0);
  const lumpTotal = lump ? (parseFloat(po.subtotal) || 0) : 0;
  const lines = items.map((li) => {
    const qty = lineQty(li), got = lineReceived(li), rem = Math.max(0, qty - got);
    if (lump) return { li, qty, got, rem, unitCost: null, total: null, receivedValue: null, outstanding: null };
    const unitCost = parseFloat(li.unit_cost) || 0;
    return { li, qty, got, rem, unitCost, total: unitCost * qty, receivedValue: unitCost * got, outstanding: unitCost * rem };
  });
  const total = lump ? lumpTotal : lines.reduce((s, l) => s + l.total, 0);
  const receivedValue = lump ? lumpTotal * frac : lines.reduce((s, l) => s + l.receivedValue, 0);
  return {
    lump, lines, frac,
    totals: { ordered, received, remaining: Math.max(0, ordered - received), total, receivedValue, outstanding: Math.max(0, total - receivedValue) },
  };
}
